<div class="alertContainer">
    <div *ngIf="show" role="alert" style="position: absolute !important" [class]="getToastClass()">
        <div class="customH5 alert-heading">
            <img class="toast-icon" *ngIf="type == 'success'" alt="tick-circle" src="/assets/green-tick-bold.svg">
            <img class="toast-icon" *ngIf="type == 'warning'" alt="exclamation-circle" src="/assets/alert-icon-small.svg">
            {{bodyText}}
            <button type="button" class="customClose close refresh toastButtons" *ngIf="action == 'refresh'" (click)="refresh()">REFRESH</button>
            <button type="button" class="customClose close toastButtons" aria-label="Close" data-dismiss="alert" *ngIf="dismissible == true" (click)="close()">OK</button>
        </div>
    </div>
</div>
